export const ACCOUNT_VERIFIED = '/account-verified';
export const APPLICATION_COMPLETE = '/application-complete';
export const APPLICATION_DENIED = '/application-denied';
export const APPLICATION_UNDER_REVIEW = '/application-under-review';
export const BUSINESS_INFO_ONE = '/business-info-1';
export const BUSINESS_INFO_TWO = '/business-info-2';
export const COUNTER_OFFER = '/counter-offer';
export const CREDIT_LOCKED = '/credit-locked';
export const DOCUMENTS = '/documents';
export const FETCHING_BANK_DATA = '/fetching-bank-data';
export const FINANCIAL_STATEMENTS = '/financial-statements';
export const FLEET_SELECTION = '/select-your-company';
export const GET_STARTED = '/get-started';
export const NO_MATCHING_FLEET = '/no-matching-fleet';
export const PERSONA = '/persona';
export const PERSONAL_INFO = '/personal-info';
export const PREQUALIFIED = '/prequalified';
export const PREVIEW_CARD = '/preview-card';
export const PRE_COLLECT_UBOS = '/pre-collect-ubos';
export const REVIEW_APPLICATION = '/review-application';
export const SPEND_INTENT = '/spend-intent';
export const VERIFY_OTP = '/verify-otp';
export const VERIFY_REVENUE = '/verify-revenue';
export const VERIFY_REVENUE_DOCS = '/verify-revenue-docs';
export const VERIFY_REVENUE_MX = '/verify-revenue-mx';
export const FLEET_VERIFIED = '/fleet-verified';
export const PARTNER_ACCOUNT_CONFLICT = '/partner-account-conflict';
